
import { Component, Input} from '@angular/core';
import { IContractStateContext } from '../state-context/state-context.interface';
import { IContractState } from '../state.interface';
// -----------------------------------------------------------------------------------------
@Component({
  templateUrl: './failure.state.html',
  styleUrls: ['./failure.state.css']
})
export class FailureStateComponent implements IContractState {
  @Input() context!: IContractStateContext;
  // -----------------------------------------------------------------------------------------
  nextState(): void {
    this.context.setInitialState();
  }
  // -----------------------------------------------------------------------------------------
}
